import {connect} from 'react-redux';

import { fetchAccountByUserId } from '../actions/users';
import { fetchLicencesByUserId } from '../actions/licences';
import {
  fetchInvitationsByUserId,
} from '../actions/invitations';
import { login } from '../reducers';
import { compose } from 'redux';
import { doFetchUserDomainInvitations } from '../actions/domains';

const mapStateToProps = ({
  usersById,
  accountsByUserId
}, {
  userId
}) => {

  const user = usersById[userId];
  const account = accountsByUserId[userId];
  
  return {
    user,
    account
  };
}

const mapDispatchToProps = (dispatch, {userId}) => ({
  fetchUserAccount: () =>
    dispatch(fetchAccountByUserId(userId)),
  fetchUserLicences: () =>
    dispatch(fetchLicencesByUserId(userId)),
  fetchUserInvitations: () =>
    dispatch(fetchInvitationsByUserId(userId)),
  fetchUserDomainInvitations: () => 
    dispatch(doFetchUserDomainInvitations(userId)),
});

export const withUserId = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const withCurrentUserId = connect(
  state => ({
    userId: login(state).id
  })
);

export const withCurrentUser = compose(
  withCurrentUserId,
  withUserId
);


// WEBPACK FOOTER //
// ./src/containers/withUser.js